module.exports = __webpack_public_path__ + "static/media/loading.1476ba30.gif";